const visaRegExp = new RegExp("^4");
const mastercardRegExp = new RegExp("^5[1-5]");

export const getPayService = (cardNumber: string) => {
    if (cardNumber.match(visaRegExp) != null) return "visa";
    if (cardNumber.match(mastercardRegExp) != null) return "mastercard";
    return "mastercard"; // default type
};
